import { render, staticRenderFns } from "./MyManuscript.vue?vue&type=template&id=2ccbf441&scoped=true"
import script from "./MyManuscript.vue?vue&type=script&lang=js"
export * from "./MyManuscript.vue?vue&type=script&lang=js"
import style0 from "./MyManuscript.vue?vue&type=style&index=0&id=2ccbf441&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbf441",
  null
  
)

export default component.exports